<template>
	<v-container style="margin-top: 4.0625rem">
		<v-fab-transition>
			<v-btn
				v-scroll="onScroll"
				v-show="fab"
				fab
				fixed
				bottom
				right
				color="primary"
				@click="toTop"
			>
				<v-icon size="28" color="white">mdi-chevron-up</v-icon>
			</v-btn>
		</v-fab-transition>
		<v-row>
			<v-col cols="12">
				<v-stepper
					flat
					v-model="paso"
					style="background-color: transparent"
				>
					<v-stepper-items>
						<v-stepper-content class="pa-0" step="1">
							<ActividadesPendientes
								v-if="paso == 1"
								@change="onChangeActividadPendiente"
							/>
						</v-stepper-content>
						<v-stepper-content class="pa-0" step="2">
							<IniciarTarea
								v-if="paso == 2"
								:actividad="actividadSelected"
								@click:cancelar="onClickCancel"
								@click:iniciar="onClickIniciar"
							/>
						</v-stepper-content>
						<v-stepper-content class="pa-0" step="3">
							<Comprobaciones
								v-if="paso == 3"
								:actividad="actividadSelected"
								@click:finalizar="onClickCancel"
								@click:salir="onClickCancel"
							/>
						</v-stepper-content>
					</v-stepper-items>
				</v-stepper>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import ActividadesPendientes from "../Mantenimiento/ActividadesPendientes/ActividadesPendientes.vue";
import Comprobaciones from "../Mantenimiento/Comprobaciones/Comprobaciones.vue";
import IniciarTarea from "../Mantenimiento/IniciarTarea/IniciarTarea.vue";

export default {
	components: { ActividadesPendientes, IniciarTarea, Comprobaciones },
	data() {
		return {
			actividadSelected: {
				idPersona: null,
				tipo: "",
				responsables: [],
				mecanicos: [],
				mantenimiento: "",
				maquina: "",
				inicioPlaneado: "",
				finPlaneado: "",
			},
			defaultActividadSelected: {
				idPersona: null,
				tipo: "",
				responsables: [],
				mecanicos: [],
				mantenimiento: "",
				maquina: "",
				inicioPlaneado: "",
				finPlaneado: "",
			},
			fab: false,
			paso: 1,
		};
	},
	methods: {
		onClickIniciar() {
			this.paso += 1;
		},
		onClickCancel() {
			this.paso = 1;
			this.$nextTick(() => {
				this.actividadSelected = JSON.parse(
					JSON.stringify(this.defaultActividadSelected)
				);
				this.toTop();
			});
		},
		onChangeActividadPendiente(actividad) {
			this.actividadSelected = JSON.parse(JSON.stringify(actividad));
			this.paso += 1;
		},
		onScroll(e) {
			if (typeof window === "undefined") return;
			const top = window.pageYOffset || e.target.scrollTop || 0;
			this.fab = top > 20;
		},
		toTop() {
			this.$vuetify.goTo(0, { duration: 300 });
		},
	},
};
</script>